import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the image studio (galleries, uploader, lightbox) isn't needed
// on the default /chat landing, so it ships as its own chunk.
const ImagesPage = lazy(() =>
  import("../components/ImagesPage").then((m) => ({ default: m.ImagesPage })),
);

/**
 * Images route — composed into the app shell layout in `app/router.tsx`. The
 * studio renders its "Creations" header into the shell topbar (TopbarSlot
 * portals), so it mounts directly under the shared top row.
 */
export function createImagesRoute<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/images",
    component: ImagesPage,
  });
}
